// @ts-nocheck
import Vue from 'vue';

import '@/config/icons';
import '@/plugins/gtm';
import '@/plugins/sentry';

import '@/directives/mask';

import '@/filters/price';

import store from '@/store/index';
import router from '@/router/router';

// main.js

import Assistant from '@/components/common/layout/Assistant.vue';
import DashboardNoResource from '@/components/common/layout/DashboardNoResource.vue';
import Loader from '@/components/common/helpers/Loader.vue';
import HighlightText from '@/components/common/helpers/HighlightText.vue';
import Icon from '@/components/common/helpers/Icon.vue';
import ClickOutside from 'vue-click-outside';
import App from './App.vue';

Vue.component('VAssistant', Assistant);
Vue.component('VNoResource', DashboardNoResource);
Vue.component('VLoader', Loader);
Vue.component('VHighlight', HighlightText);
Vue.component('VIcon', Icon);

Vue.directive('ClickOutside', ClickOutside);

Vue.config.productionTip = true;
Vue.config.devtools = import.meta.env.VITE_TOOLS;

new Vue({
  router,
  store,
  render: (h) => h(App, { }),
}).$mount('#app');
